import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import { changeLanguage } from "redux/actions/globalSlice/globalSlice";
import { languages_enum } from "redux/actions/globalSlice";
import { LocalStorage } from "config/keys";

const supportedLangs = [languages_enum.ENGLISH, languages_enum.RUSSIAN]; // default is Georgian

export const LanguageDetector = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const firstSegment = location.pathname.split("/")[1];
    const langFromPath = supportedLangs.includes(firstSegment as languages_enum)
      ? (firstSegment as languages_enum)
      : languages_enum.GEORGIAN;

    localStorage.setItem(LocalStorage.language, langFromPath);
    dispatch(changeLanguage(langFromPath));
  }, [location.pathname]);

  return null;
};
